import React from "react";
import { Spinner } from "./Spinner";

export default function PageOverlay(props) {
	return (
		<React.Fragment>
			{props.showOverlay ? (
				<div className="overlay" style={props.style}>
					<div className="overlay-opacity" />
					<Spinner style={{ margin: 15 }} />
					{props.children}
				</div>)
				: (<React.Fragment></React.Fragment>)}
		</React.Fragment>
	);
}
